<template>
  <page-with-aside :hasFooter="true">
    <template #navheader>
      <header class="page-header">
        <nav>
          <a href="#/login" class="button">Returning User Log in</a>
          <router-link to="/" class="button">Back to home page</router-link>
        </nav>
      </header>
    </template>

    <template #content>
      <section class="content-header">
        <h2>About the Open to Options Program</h2>
        <p>
          The Cancer Support Community (CSC) created the Open to Options program
          to help cancer patients as they prepare to make an upcoming treatment
          decision. The program involves meeting with a trained specialist who
          guides the patient through a structured, non-directive interaction to
          elicit their questions, concerns and priorities. At the end of the
          session, patients have a curated list of questions prepared for their
          upcoming medical appointment.
        </p>
        <p>
          In an effort to reach a wider audience, CSC created an interactive chatbot experience that
          simulates the in-person experience of Open to Options.
        </p>
        <p>
          Following the same structure as the in-person interaction, the Open to
          Options chatbot provides an engaging conversational experience that
          involves the exchange of information, the opportunity for reflection,
          and the expression of emotional support.
        </p>
      </section>

      <article class="grid-section">
        <section class="content text">
          <h3>About the Cancer Support Community</h3>
          <p>
            As the largest professionally led nonprofit network of cancer
            support worldwide, the Cancer Support Community (CSC) is dedicated
            to ensuring that all people impacted by cancer are empowered by
            knowledge, strengthened by action, and sustained by community. This
            global network of 175 locations, including CSC and Gilda's Club
            centers, health-care partnerships, and satellite locations that
            deliver more than $50 million in free support services to patients
            and families. In addition, CSC administers a toll-free helpline and
            produces award-winning educational resources that reach more than
            one million people each year.
          </p>
          <p>
            Formed in 2009 by the merger of The Wellness Community and Gilda’s
            Club, CSC also conducts cutting-edge research on the emotional,
            psychological, and financial journey of cancer patients. In
            addition, CSC advocates at all levels of government for policies to
            help individuals whose lives have been disrupted by cancer. In
            January 2018, CSC welcomed Denver-based nonprofit MyLifeLine, a
            digital community that includes more than 30,000 patients,
            caregivers, and their supporters that will enable CSC to scale its
            digital services in an innovative, groundbreaking way.
          </p>
        </section>
      </article>
    </template>
  </page-with-aside>
</template>

<script>
import PageWithAside from "@/components/PageWithAside.vue";

export default {
  name: "About",
  components: {
    PageWithAside,
  },
  methods: {
    goToChat() {
      this.$router.push("/chat/situation/new/");
      this.changeMode("chat");
    },
  },
};
</script>

<style scoped lang="scss">
.grid-section {
  @media (min-width: 800px) {
    grid-template-columns: [text-start] 3fr [text-end image-start] 1fr [image-end];

    .text {
      grid-column: text-start/text-end;
    }
    .images {
      grid-column: image-start/image-end;
    }
  }
}
img {
  max-width: 250px;
  @media (min-width: 1200px) {
    max-width: 300px;
  }
}
.link-section {
  margin-top: 1rem;
}
</style>
